export * from './useEidCommonFieldsStructure';

export * from './useEidDependentsFieldsStructure';

export * from './useEidDomesticWorkerFieldsStructure';

export * from './useEidPrincipalFieldsStructure';
